<template>
  <div class="main">
    <div class="form-bg">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="$t('userInfo.username')" prop="username">
          <el-input type="text" v-model="ruleForm.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('userInfo.password')" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="submitForm('ruleForm')">{{this.$t('common.login')}}</el-button>
          <el-button type="success" plain  @click="register()">{{this.$t('common.Register')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import axios from '../axios'

  export default {
    name: 'login',
    data() {
      var validateusername = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.enterName')));
        } else {
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('message.enterPWD')));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };

      return {
        ruleForm: {
          username: '',
          pass: '',

        },
        rules: {
          username: [
            {validator: validateusername, trigger: 'blur'}
          ],
          pass: [
            {validator: validatePass, trigger: 'blur'}
          ],

        }
      };
    },
    created: function () {

    },
    methods: {
      submitForm(formName) {
        let _this = this;
        let username = this.ruleForm.username;
        let password = this.ruleForm.pass;

        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios.post(this.$store.state.apiBasePath + "/login", {
              username: username,
              password: password
            }).then(function (res) {
              var data = res.data;
              if (data.code == 200) {
                localStorage.setItem('loginToken', data.token);
                localStorage.setItem('nickname', data.nickname);
                sessionStorage.setItem('menuIndex',0);
                _this.$router.push('/');
                // window.location.href='#/';
              } else {
                _this.$message({
                  type: 'error',
                  title: this.$t('message.Error'),
                  message:res.data.msg,
                  showClose: true,
                  offset:300,
                  duration:3000,
                });
              }
            })
          } else {
            return false;
          }
        });
      },
      register() {
        this.$router.push('/register')
      }
    }


  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    width: 1170px;
    margin: 15px auto;
    display: flex;
    min-height: calc(100% - 486px);
  }

  .form-bg {
    width: 500px;
    margin: 80px auto;
    background: #fff;
    border: #ddd 1px solid;
    padding: 30px 30px;
    border-radius: 5px;
    box-shadow: #ddd 0 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue